'use client';

import React, { useEffect, useState } from 'react';
import { createClient } from '@/lib/supabase/client';

interface Attraction {
  id: string;
  emoji: string;
  label: string;
  sort_order: number;
}

const FALLBACK_ATTRACTIONS: Attraction[] = [
  { id: 'attr-dino', emoji: '🦕', label: 'Dinosaur Experience', sort_order: 1 },
  { id: 'attr-falcon', emoji: '🦅', label: 'Falconry Displays', sort_order: 2 },
  { id: 'attr-wrestling', emoji: '🤼', label: 'Wrestling Shows', sort_order: 3 },
  { id: 'attr-arena', emoji: '🎭', label: 'Arena Entertainment', sort_order: 4 },
  { id: 'attr-dog', emoji: '🐕', label: 'Dog Show', sort_order: 5 },
  { id: 'attr-train', emoji: '🚂', label: 'Land Train', sort_order: 6 },
  { id: 'attr-rc', emoji: '🏎️', label: 'RC Cars', sort_order: 7 },
  { id: 'attr-sports', emoji: '⚽', label: 'Sports Fair', sort_order: 8 },
  { id: 'attr-bounce', emoji: '🏰', label: 'Bouncy Castles', sort_order: 9 },
  { id: 'attr-axe', emoji: '🪓', label: 'Axe Throwing', sort_order: 10 },
  { id: 'attr-laser', emoji: '🎯', label: 'Laser Clay', sort_order: 11 },
  { id: 'attr-food', emoji: '🍔', label: 'Food & Drinks', sort_order: 12 },
  { id: 'attr-stalls', emoji: '🛍️', label: 'Local Stalls', sort_order: 13 },
  { id: 'attr-boot', emoji: '🚗', label: 'Car Boot Sale', sort_order: 14 },
];

export default function AttractionsGrid() {
  const [attractions, setAttractions] = useState<Attraction[]>(FALLBACK_ATTRACTIONS);

  useEffect(() => {
    const supabase = createClient();
    supabase
      .from('attractions')
      .select('id, emoji, label, sort_order')
      .eq('visible', true)
      .order('sort_order', { ascending: true })
      .then(({ data }) => {
        if (data && data.length > 0) setAttractions(data);
      });
  }, []);

  return (
    <section>
      <h2 className="text-section-title text-foreground mb-4">Attractions Include</h2>
      <div className="grid grid-cols-2 gap-2.5">
        {attractions?.map((item) => (
          <div
            key={item?.id}
            className="bg-card rounded-xl p-3 card-shadow border border-border flex items-center gap-3 active:scale-95 transition-all duration-150"
          >
            <span className="text-2xl">{item?.emoji}</span>
            <span className="text-sm font-semibold text-foreground leading-tight">{item?.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}